import { render, staticRenderFns } from "./SubscribeOrderDeliver.vue?vue&type=template&id=5825e549"
import script from "./SubscribeOrderDeliver.vue?vue&type=script&lang=js"
export * from "./SubscribeOrderDeliver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports